import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './index.css';

import Navbar from './components/Navbar';
import Footer from './components/Footer';

import Home from './pages/Home';
import Servicos from './pages/Servicos';
import Contato from './pages/Contato';
import Suporte from './pages/Suporte';
import Lgpd from './pages/Lgpd';
import Cloud from './pages/Cloud';
import Infraestrutura from './pages/Infraestrutura';
import Seguranca from './pages/Seguranca';
import Redes from './pages/Redes';

const pageVariants = {
  initial: { opacity: 0, y: 20 },
  in: { opacity: 1, y: 0 },
  out: { opacity: 0, y: -20 }
};

const pageTransition = {
  type: "tween",
  ease: "easeInOut",
  duration: 0.4
};

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        {[
          ['/', <Home />],
          ['/servicos', <Servicos />],
          ['/contato', <Contato />],
          ['/suporte', <Suporte />],
          ['/lgpd', <Lgpd />],
          ['/cloud', <Cloud />],
          ['/infraestrutura', <Infraestrutura />],
          ['/seguranca', <Seguranca />],
          ['/redes', <Redes />],
          ['*', <Home />]
        ].map(([path, Element]) => (
          <Route
            key={path}
            path={path}
            element={
              <motion.div
                initial="initial"
                animate="in"
                exit="out"
                variants={pageVariants}
                transition={pageTransition}
              >
                {Element}
              </motion.div>
            }
          />
        ))}
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  return (
    <Router>
      <div className="overlay text-center">
        <Navbar />
        <AnimatedRoutes />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
